import packageJson from "../../../package.json"
import Falcon from "../../components/pages/ap_falcon";

export const CONSTANTS = {
  ACCESS_LOGS: "accessLogs",
  LOGIN_LOGS: "loginLogs",
  REASON_LOGS: "reasonLogs",
  ACCESS_LOGS_FILENAME: "Access_Log",
  LOGIN_LOGS_FILENAME: "Login_Log",
  REASON_LOGS_FILENAME: "Reason_Log",
  EMPLOYEE_MASTER_DASHBOARD: "EMPLOYEE_MASTER_DASHBOARD1",
  EMPLOYEE_MASTER_SNAPSHOT: "EMPLOYEE_MASTER_SNAPSHOT",
  EMPLOYEE_MASTER_SNAPSHOT_LOGS: "EMPLOYEE_MASTER_SNAPSHOT_LOGS",
  AUTO_PROVISIONING_PROHANCE: "AUTO_PROVISIONING_PROHANCE",
  AUTO_PROVISIONING_PIXIE: "AUTO_PROVISIONING_PIXIE",
  FALCON_LOGS:"FALCON_LOGS",
  PROHANCE:'Prohance',
  FALCON:'Falcon',
  CAMPAIGN:'Campaign',
  GROUP:'Group',
  DATABASE:"Database",
  MANAGEJOBS: "ManageJobs"
};

export const MetaTitle={
  Login:"",
  Falcon:`- ${packageJson.version} - Falcon`,
  Prohance:`- ${packageJson.version} - Prohance`,
  ProhanceCondition:`- ${packageJson.version} - Prohance Condition Filters`,
  FalconCondition:`- ${packageJson.version} - Falcon Condition Filters`,
  Dashboard:`- ${packageJson.version} - Dashboard`,
  Snapshot:`- ${packageJson.version} - Snapshot`,
  Logs:`- ${packageJson.version} - Logs`,
  LogsDetails:`- ${packageJson.version} - Logs Details`,
  FalconLogs:`- ${packageJson.version} - Falcon Logs`,
  FalconLogsDetails:`- ${packageJson.version} - Falcon Logs Details`,

}
export const DASHBOARD = {
  DOWNLOADS_BY_FUNCTION: "downloadsByFunction",
  TOP_FUNTIONS: "topFunctions",
  DOWNLOADS_BY_USER: "downloadsByUser",
  DOWNLOADS_BY_SITE: "downloadsBySite",
  RECENT_ACTIVITY: "recentActivity",
  RECENT_DOWNLOAD_REASONS: "recentDownloadReasons",
  DOWNLOADS_BY_CAMPAIGN: "downloadsByCampaign",
};

export const HEADERS_FOR_FUNCTION_DOWNLOADS = [
  { label: "Funtion Name", key: "position" },
  { label: "Downloads", key: "downloads" },
];

export const HEADERS_FOR_USER_DOWNLOADS = [
  { label: "Email", key: "position" },
  { label: "Downloads", key: "downloads" },
];

export const HEADERS_FOR_SITE_DOWNLOADS = [
  { label: "Site Name", key: "position" },
  { label: "Downloads", key: "downloads" },
];

export const HEADERS_FOR_RECENT_ACTIVITY = [
  { label: "User Name", key: "user_name" },
  { label: "Activity Time", key: "created_at" },
];

export const HEADERS_FOR_RECENT_DOWNLOAD_REASONS = [
  { label: "User Name", key: "user_name" },
  { label: "Reason", key: "reasons_reason" },
  { label: "Activity Time", key: "created_at" },
];

export const HEADERS_FOR_CAMPAIGN_DOWNLOADS = [
  { label: "Campaign", key: "position" },
  { label: "Downloads", key: "downloads" },
];

export const HEADERS_FOR_SNAPSHOT_EXPORT = [
  { label: "EMPLOYEE ID", key: "employee_id" },
  { label: "EMAIL", key: "email" },
  { label: "FULL NAME", key: "full_name" },
  { label: "HIRE DATE", key: "hire_date" },
  { label: "POSITION JOB DESCRIPTION", key: "position_job_description" },
  { label: "CAMPAIGN", key: "campaign" },
  { label: "LOB", key: "lob" },
  { label: "SITE", key: "site" },
  { label: "IS ID", key: "isid" },
  { label: "IS FIRST NAME", key: "is_first_name" },
  { label: "IS LAST NAME", key: "is_last_name" },
  { label: "OPERATIONS MANAGER", key: "operations_manager" },
  { label: "SENIOR OPERATIONS MANAGER", key: "senior_operations_manager" },
  { label: "DEPARTMENT", key: "department" },
  { label: "WORK SITE STATUS", key: "work_site_status" },
];

export const CLIENT_PROHANCE = "PROHANCE";

export const AUTO_PROVISIONING_CLIENT = {
  PROHANCE: "PROHANCE",
  FALCON: "PIXIEBRIX",
};

export const JOB_TYPE = {
  PROHANCE_AUTO_PROVISIONING: "PROHANCE_AUTO_PROVISIONING",
  PIXIEBRIX_AUTO_SYNC: "PIXIEBRIX_AUTO_SYNC",
  PIXIEBRIX_CAMPAIGN_SYNC:'PIXIEBRIX_CAMPAIGN_SYNC',
  PIXIEBRIX_GROUP_SYNC:'PIXIEBRIX_GROUP_SYNC',
  PIXIEBRIX_TEAM_LEADER_SYNC:'PIXIEBRIX_DB_DATA_SYNC'
};

export const CRON_JOB_NAME = {
  EMPLOYEE_MASTER_SYNC: "EmployeeMasterSyncJob",
  AD_MANAGER_SYNC: "AdManagerSyncJob",
  PIXIEBRIX_TEAM_LEAD_SYNC: "PixiebrixDBDataSynchJob",
  PIXIEBRIX_CAMPAIGN_SYNC: "PixiebrixCampaignSynchJob",
  PIXIEBRIX_GROUP_SYNC: "PixiebrixGroupSynchJob",
  AP_PROHANCE_SYNC: "ProhanceSynchJob",
  AP_FALCON_SYNC: "PixiebrixSynchJob",

};

export const JOB_STATUS = {
  STARTED: "Started",
  ERROR: "Error",
  INPROGRESS: "InProgress",
  FINISHED: "Finished"
};

export const URLPATTERN = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/

export const FALCONDATATYPE = [
  {
    key: "CAMPAIGN",
    label: "Campaign",
  },
  {
    key: "GROUP",
    label: "Group",
  },
  {
    key: "DATABASE",
    label: "Database",
  },
];

export const CronExpression = [
  // { label: "EVERY_SECOND", key: "* * * * * *",jobstatus:true},
  // { label: "EVERY_5_SECONDS", key: "*/5 * * * * *" },
  // { label: "EVERY_10_SECONDS", key: "*/10 * * * * *" },
  // { label: "EVERY_30_SECONDS", key: "*/30 * * * * *" },
  // { label: "EVERY_MINUTE", key: "*/1 * * * *" },
  // { label: "EVERY_5_MINUTES", key: "0 */5 * * * *" },
  // { label: "EVERY_10_MINUTES", key: "0 */10 * * * *" },
  { label: "EVERY_30_MINUTES", key: "0 */30 * * * *" },
  { label: "EVERY_HOUR", key: "0 0-23/1 * * *" },
  { label: "EVERY_2_HOURS", key: "0 0-23/2 * * *" },
  { label: "EVERY_3_HOURS", key: "0 0-23/3 * * *" },
  { label: "EVERY_4_HOURS", key: "0 0-23/4 * * *" },
  { label: "EVERY_5_HOURS", key: "0 0-23/5 * * *" },
  { label: "EVERY_6_HOURS", key: "0 0-23/6 * * *" },
  { label: "EVERY_7_HOURS", key: "0 0-23/7 * * *" },
  { label: "EVERY_8_HOURS", key: "0 0-23/8 * * *" },
  { label: "EVERY_9_HOURS", key: "0 0-23/9 * * *" },
  { label: "EVERY_10_HOURS", key: "0 0-23/10 * * *" },
  { label: "EVERY_11_HOURS", key: "0 0-23/11 * * *" },
  { label: "EVERY_12_HOURS", key: "0 0-23/12 * * *" },
  { label: "EVERY_DAY_AT_1AM", key: "0 01 * * *" },
  { label: "EVERY_DAY_AT_2AM", key: "0 02 * * *" },
  { label: "EVERY_DAY_AT_3AM", key: "0 03 * * *" },
  { label: "EVERY_DAY_AT_4AM", key: "0 04 * * *" },
  { label: "EVERY_DAY_AT_5AM", key: "0 05 * * *" },
  { label: "EVERY_DAY_AT_6AM", key: "0 06 * * *" },
  { label: "EVERY_DAY_AT_7AM", key: "0 07 * * *" },
  { label: "EVERY_DAY_AT_8AM", key: "0 08 * * *" },
  { label: "EVERY_DAY_AT_9AM", key: "0 09 * * *" },
  { label: "EVERY_DAY_AT_10AM", key: "0 10 * * *" },
  { label: "EVERY_DAY_AT_11AM", key: "0 11 * * *" },
  { label: "EVERY_DAY_AT_NOON", key: "0 12 * * *" },
  { label: "EVERY_DAY_AT_1PM", key: "0 13 * * *" },
  { label: "EVERY_DAY_AT_2PM", key: "0 14 * * *" },
  { label: "EVERY_DAY_AT_3PM", key: "0 15 * * *" },
  { label: "EVERY_DAY_AT_4PM", key: "0 16 * * *" },
  { label: "EVERY_DAY_AT_5PM", key: "0 17 * * *" },
  { label: "EVERY_DAY_AT_6PM", key: "0 18 * * *" },
  { label: "EVERY_DAY_AT_7PM", key: "0 19 * * *" },
  { label: "EVERY_DAY_AT_8PM", key: "0 20 * * *" },
  { label: "EVERY_DAY_AT_9PM", key: "0 21 * * *" },
  { label: "EVERY_DAY_AT_10PM", key: "0 22 * * *" },
  { label: "EVERY_DAY_AT_11PM", key: "0 23 * * *" },
  { label: "EVERY_DAY_AT_MIDNIGHT", key: "0 0 * * *" },
  { label: "EVERY_WEEK", key: "0 0 * * 0" },
  { label: "EVERY_WEEKDAY", key: "0 0 * * 1-5" },
  { label: "EVERY_WEEKEND", key: "0 0 * * 6,0" },
  { label: "EVERY_1ST_DAY_OF_MONTH_AT_MIDNIGHT", key: "0 0 1 * *" },
  { label: "EVERY_1ST_DAY_OF_MONTH_AT_NOON", key: "0 12 1 * *" },
  { label: "EVERY_2ND_HOUR", key: "0 */2 * * *" },
  { label: "EVERY_2ND_HOUR_FROM_1AM_THROUGH_11PM", key: "0 1-23/2 * * *" },
  { label: "EVERY_2ND_MONTH", key: "0 0 1 */2 *" },
  { label: "EVERY_QUARTER", key: "0 0 1 */3 *" },
  { label: "EVERY_6_MONTHS", key: "0 0 1 */6 *" },
  { label: "EVERY_YEAR", key: "0 0 1 0 *" },
  { label: "EVERY_30_MINUTES_BETWEEN_9AM_AND_5PM", key: "0 */30 9-17 * * *" },
  { label: "EVERY_30_MINUTES_BETWEEN_9AM_AND_6PM", key: "0 */30 9-18 * * *" },
  { label: "EVERY_30_MINUTES_BETWEEN_10AM_AND_7PM", key: "0 */30 10-19 * * *" },
  { label: "MONDAY_TO_FRIDAY_AT_1AM", key: "0 0 01 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_2AM", key: "0 0 02 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_3AM", key: "0 0 03 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_4AM", key: "0 0 04 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_5AM", key: "0 0 05 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_6AM", key: "0 0 06 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_7AM", key: "0 0 07 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_8AM", key: "0 0 08 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_9AM", key: "0 0 09 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_09_30AM", key: "0 30 09 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_10AM", key: "0 0 10 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_11AM", key: "0 0 11 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_11_30AM", key: "0 30 11 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_12PM", key: "0 0 12 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_1PM", key: "0 0 13 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_2PM", key: "0 0 14 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_3PM", key: "0 0 15 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_4PM", key: "0 0 16 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_5PM", key: "0 0 17 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_6PM", key: "0 0 18 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_7PM", key: "0 0 19 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_8PM", key: "0 0 20 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_9PM", key: "0 0 21 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_10PM", key: "0 0 22 * * 1-5" },
  { label: "MONDAY_TO_FRIDAY_AT_11PM", key: "0 0 23 * * 1-5" },
];
